import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { TabContent } from '../../models/tab-content.model';
import { GlobalElementType } from '../../enums/global-element-type-uid.enum';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'vm-tab-section',
  templateUrl: './tab-section.component.html',
  styleUrls: ['./tab-section.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TabSectionComponent implements OnInit {
  //@Output() selectedCard = new EventEmitter();
  @Input() data: TabContent;
  @Input() isModal = false;
  strapiUrl = environment.strapiURL;
  globalElementType = GlobalElementType;

  constructor() {}

  ngOnInit() {
    this.data.items.forEach((item) => {
      document.querySelectorAll(`.${item.productId}`).forEach((element) => {
          element.classList.add('hide');
      });
    });
  }

  public onSelectedCard(event) {
    const id = event.productId;

    this.data.items.forEach((item) => {
      document.querySelectorAll(`.${item.productId}`).forEach((element) => {
          element.classList.add('hide');
          element.classList.remove('show');
      });
    });

    document.querySelectorAll(`.${id}`).forEach((item) => {
        item.classList.add('show');
        item.classList.remove('hide');
    });
    document?.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  }
}
